import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuTrigger,
  DropdownMenuGroup,
  DropdownMenuItem,
} from "@/components/shadcn/dropdown-menu"
import { Button } from "@/components/shadcn/button"
import { Icon } from "@iconify-icon/solid";
import { cn } from "@/libs/cn";

export const ActionDropdown = (props) => {
  return (
    <DropdownMenu placement="bottom-end">
      <DropdownMenuTrigger as={innerProps => <Button variant={props.asIcon ? "ghost" : "outline"} class="h-6 w-2" {...innerProps} />}>
        <Icon icon="mdi:dots-vertical" />
        <span class="sr-only">Row menu</span>
      </DropdownMenuTrigger>
      <DropdownMenuContent>
        <DropdownMenuGroup>
          {props.children}
        </DropdownMenuGroup>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}

export const ActionDropdownMenuItem = (props) => {
  return (
    <DropdownMenuItem class="text-xs" onClick={props.onClick}>
      <Icon icon={props.icon} class="me-1" />
      {props.children}
    </DropdownMenuItem>
  );
}

export const ActionDropdownMenuItemLink = (props) => {
  return (
    <DropdownMenuItem class="text-xs" as={(innerProps) => <a href={props.href} {...innerProps} />}>
      <Icon icon={props.icon} class="me-1" />
      {props.children}
    </DropdownMenuItem>
  );
}

export const EditDropdownMenuItem = ({ onClick }) => {
  return (
    <ActionDropdownMenuItem icon="basil:edit-outline" onClick={onClick}>
      Edit
    </ActionDropdownMenuItem>
  );
}

export const EditDropdownMenuItemLink = (props) => {
  return (
    <ActionDropdownMenuItemLink icon="basil:edit-outline" href={"/" + props.url + "/" + props.key + "/edit"}>
      Edit
    </ActionDropdownMenuItemLink>
  );
}

export const ActivateDropdownItem = ({ onClick }) => {
  return (
    <ActionDropdownMenuItem icon="humbleicons:switch-on" onClick={onClick}>
      Activate
    </ActionDropdownMenuItem>
  );
}

export const DeactivateDropdownItem = ({ onClick }) => {
  return (
    <ActionDropdownMenuItem icon="humbleicons:switch-off" onClick={onClick}>
      Deactivate
    </ActionDropdownMenuItem>
  );
}

export const DeleteDropdownItem = ({ onClick }) => {
  return (
    <ActionDropdownMenuItem icon="humbleicons:trash" onClick={onClick}>
      Delete
    </ActionDropdownMenuItem>
  );
}
